import APIService from '../api.service';

export const All = (params) => {
  return APIService.get(`/v01/stock-returns`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      status: params.status,
      shop_id: params.shop_id,
      from_date: params.date,
      to_date: params.date,
      keyword: params.keyword,
    },
  });
};

export const Details = (id) => {
  return APIService.get(`/v01/stock-returns/${id}`);
};

export const UpdateStatus = (id, data) => {
  return APIService.put(`/v01/stock-returns/${id}/status`, data);
};

export const DownloadStockReturnPivotExport = (params) => {
  return APIService.get(`/v01/stock-returns-pivot-export`, {
    params,
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
};

const StockReturnService = {
  All,
  Details,
  UpdateStatus,
  DownloadStockReturnPivotExport,
}

export default StockReturnService;